module.exports = {
      id: "speaker-usage",
      viewBox: "0 0 15 12",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#speaker",
      toString: function () {
        return this.url;
      }
    }